import { TestCentre } from "@ds-developer/test-centres/dist/types";
import { useFormContext } from "react-hook-form/dist/react-hook-form.ie11";
import React from "react";
import TestCentres from "@ds-developer/test-centres";
type StateProviderProps = {
  data: TestCentre[];
};
const StateProvider: React.FC<StateProviderProps> = ({ data }) => {
  const { watch, setValue } = useFormContext();
  const testCentres: TestCentre[] = watch("testCentres") ?? [];

  return (
    <TestCentres
      title="Search for test centres you cover in all your areas."
      data={data.sort((a, b) => a.name.localeCompare(b.name))}
      testCentres={testCentres.sort((a, b) => a.name.localeCompare(b.name))}
      setValue={value => setValue("testCentres", value)}
    />
  );
};

export default StateProvider;
